import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDeleteScenarioPool = () => {
  const { invalidateQuery: invalidateViewQueries } = useInvalidateQueries(
    QueryKey.GET_SCENARIO_POOLS,
  );

  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: deleteScenarioPool, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_POOL],
    {
      mutationFn: ({ scenarioId, poolId }: { poolId: string; scenarioId: string }) =>
        ApiService.delete({
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'pools', poolId],
        }),
      onSuccess: () => {
        invalidateViewQueries();
        invalidateCalculationQueries();
      },
    },
  );
  return { deleteScenarioPool, isPending };
};
